import React from "react";
import { ThreeDots } from 'react-loader-spinner'

export default function Loader({ isLoading }) {
    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 text-center">
                        {/* /.card */}
                        <div className="card">
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#6610f2"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ margin: '150px auto' }}
                                wrapperClass="custom-loader"
                                visible={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}